import { useContext } from 'react';
import { LayoutHandlersContext } from '../../context/LayoutHandlersContext/LayoutHandlersContext';
import { LayoutHandlersContextType } from '../../types/context';

// Region-scoped context (layout editor page only) — consumers like
// SettingsPanelItem must work without the provider too, so this accessor
// never throws; the defaults are handler no-ops.
export const useLayoutHandlersContext = (): LayoutHandlersContextType =>
  useContext(LayoutHandlersContext);
